import { render, staticRenderFns } from "./BubbleMenuDropdown.vue?vue&type=template&id=44510f88&scoped=true"
import script from "./BubbleMenuDropdown.vue?vue&type=script&lang=js"
export * from "./BubbleMenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./BubbleMenuDropdown.vue?vue&type=style&index=0&id=44510f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44510f88",
  null
  
)

export default component.exports